export const openUrlInNewTab = (url) => {
  const newTab = window && window.open(url, '_blank');
  if (newTab) newTab.focus();
};
